import { useRouter } from 'next/router'
import Link from 'next/link'
import tw, { styled, theme } from 'twin.macro'

const StyledPostTypeRow = styled.div`
  padding: 10px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 8px;
  position: sticky;
  top: 60px;
  background-color: white;
  z-index: 10;

  ${tw` md:p-0`};

  @media (min-width: ${theme`screens.md`}) {
    max-width: 720px;
    margin: 0 auto;
    top: 80px;
    padding-bottom: 16px;
  }
  @media (min-width: ${theme`screens.lg`}) {
    max-width: 960px;
    margin: 0 auto;
    top: 80px;
    padding-bottom: 16px;
  }
`

const StyledPostTypeButton = styled.button<{ isActive: boolean }>`
  color: ${({ isActive }) => (isActive ? '#fff' : '#333')};
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  background-color: ${({ isActive }) => (isActive ? '#7d7af4' : '#f7f7f7')};
`

export const HideBarClass = ['trend', 'diary', 'entertainment', 'sport', undefined]

const PostTypeBar = () => {
  const { pathname, query } = useRouter()
  let postTypes = Array.isArray(query.postTypes) ? query.postTypes : query.postTypes?.split(',')
  if (!postTypes || postTypes.length === 0) postTypes = ['web']
  const activeTab = postTypes.length == 2 ? 'all' : postTypes[0]

  if (HideBarClass.includes(query.clas as string)) {
    return null
  }

  return (
    <StyledPostTypeRow>
      <Link
        href={{
          pathname,
          query: { ...query, postTypes: 'web' },
        }}
        passHref
      >
        <StyledPostTypeButton isActive={activeTab === 'web'}>編輯精選</StyledPostTypeButton>
      </Link>
      <Link
        href={{
          pathname,
          query: { ...query, postTypes: 'user' },
        }}
        passHref
      >
        <StyledPostTypeButton isActive={activeTab === 'user'}>創作者精選</StyledPostTypeButton>
      </Link>
      <Link
        href={{
          pathname,
          query: { ...query, postTypes: 'web,user' },
        }}
        passHref
      >
        <StyledPostTypeButton isActive={activeTab === 'all'}>全部文章</StyledPostTypeButton>
      </Link>
    </StyledPostTypeRow>
  )
}

export default PostTypeBar
